import { useListsContext } from '../../../contexts';

export const useItemsToDeleteContent = () => {
  const { listsToDelete } = useListsContext();
  return listsToDelete.map(({ id, name }) => ({ id, name }));
};
